import { DropDetails } from 'components/well/constants';
import { getCanvasPointerPosition } from '../utils';
import { DrawingType, POIDrawing, PoiUpdateDetails } from '../constants';
import { getNewId } from 'utils/Global';
import { useAllSelectedWellDrawingsByType, usePoiDrawingColor } from 'redux/hooks/well';
import TransformPoints from 'components/plateviewer/well/TransformPoints';
import { WellDetailsStates } from 'business/models/CustomModels';

let poiDrawing: PoiUpdateDetails = null;

function getNewPoiName(pois) {
  if (!pois?.length) {
    return 'p1';
  }

  const poiNumbers = new Set();

  pois.forEach((r) => {
    const poiText = r.name.slice(1);
    const poiNum = parseInt(poiText);
    if (!isNaN(poiNum)) {
      poiNumbers.add(poiNum);
    }
  });

  let newPoiNumber = 1;
  while (poiNumbers.has(newPoiNumber)) {
    newPoiNumber++;
  }

  return `p${newPoiNumber}`;
}

export const usePoiCreateHandlers = (
  wellDetails: DropDetails | WellDetailsStates,
  regionName: string,
  tpObject: TransformPoints,
) => {
  const allPoiDrawings = useAllSelectedWellDrawingsByType(
    wellDetails.plateID,
    wellDetails.wellNum,
    wellDetails.dropNumber,
    regionName,
    DrawingType.POI,
  ) as POIDrawing[];
  const poiDrawingColor = usePoiDrawingColor();
  const onMouseDown: (e) => { drawing: PoiUpdateDetails; type: DrawingType } = (e) => {
    const { x, y } = getCanvasPointerPosition(e);
    const [dbX, dbY] = tpObject.FromCanvasToDb(x, y);
    poiDrawing = {
      id: getNewId(),
      name: getNewPoiName(allPoiDrawings),
      x,
      y,
      dbX,
      dbY,
      zIndex: 0,
      isNewDrawing: true,
      color: poiDrawingColor,
    };
    return { drawing: poiDrawing, type: DrawingType.POI };
  };

  const onMouseMove: (e) => {
    drawing: PoiUpdateDetails;
    type: DrawingType;
    isDrawingFirstClick: boolean;
  } = (e) => {
    return null;
  };

  const onMouseUp: (e) => { drawing: PoiUpdateDetails; type: DrawingType } = (e) => {
    poiDrawing = {
      ...poiDrawing,
      isNewDrawing: false,
    };
    return { drawing: poiDrawing, type: DrawingType.POI };
  };

  return { onMouseDown, onMouseMove, onMouseUp };
};
